import { render, staticRenderFns } from "./juese_com.vue?vue&type=template&id=2d0490b5&scoped=true"
import script from "./juese_com.vue?vue&type=script&lang=js"
export * from "./juese_com.vue?vue&type=script&lang=js"
import style0 from "./juese_com.vue?vue&type=style&index=0&id=2d0490b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0490b5",
  null
  
)

export default component.exports